import { useState } from 'react'
import VebinarCard from '../../../entities/vebinars/VebinarCard'
import VebinarModal from '../../../entities/vebinars/VebinarModal'
import styles from './VebinarItem.module.scss'

export function VebinarItem({ item }) {
    const [active, setActive] = useState(false)

    const handleClose = () => {
        setActive(false)
    }

    return (
        <>
            <VebinarCard item={item} clickHandler={() => setActive(true)} />
            <VebinarModal
                item={item}
                active={active}
                handleClose={handleClose}
            />
        </>
    )
}
